export enum EInviteInputType {
  FirstName = 'firstName',
  LastName = 'lastName',
  Email = 'email',
  Mobile = 'mobile',
}
